<template>
  <span class="netBudget">
    (NET)
    <AppCurrency :value="value" />
  </span>
</template>

<script>
export default {
  name: 'NetBudget',
  props: {
    value: {
      type: Number,
    },
  },
}
</script>

<style lang="scss" scoped>
.netBudget {
  color: #3399ff;
}
</style>
